"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, FormErrorSummary } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsFormErrorSummary() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Form Error Summary
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays a summary of form validation errors at the top of a form.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/form-error-summary" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Error summary with multiple errors</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <FormErrorSummary
            errors={[
              { field: "email", message: "Email is required" },
              { field: "password", message: "Password must be at least 8 characters" },
              { field: "username", message: "Username is already taken" },
            ]}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">errors</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">{"{ field: string; message: string }[]"}</td>
                <td className="py-2 text-muted-foreground">Array of error objects</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">title</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Summary title (default: "Please fix the following errors:")</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
